import * as React from 'react';
import clsx from 'clsx';
import checkIcon from '@/assets/images/svg/purple_check_icon.svg';

interface ChargeDetailsProps {
  isActivated?: boolean;
  variant?: 'free' | 'premium';
}

/** Displays activation status and cost for free/premium internet search. */
export const ChargeDetails: React.FC<ChargeDetailsProps> = ({
  isActivated = false,
  variant = 'free',
}) => {
  const isPremium = variant === 'premium';

  return (
    <div className={clsx('w-full rounded-20 p-6', 'bg-gray-100', 'flex items-center gap-4')}>
      {isActivated ? (
        <img src={checkIcon} alt='' className='size-6 shrink-0' />
      ) : (
        <div className='size-6 shrink-0 rounded-full border-2 border-gray-300' />
      )}
      <div className='flex flex-col'>
        <span className='font-sans text-16 font-bold leading-20 text-brand-800'>
          {isActivated
            ? isPremium
              ? 'Premium search activated'
              : 'Internet search activated'
            : isPremium
              ? 'Activate premium search — 55 credits'
              : 'Activate internet search'}
        </span>
        <span className='mt-1 font-sans text-14 font-normal leading-20 text-gray-500'>
          {isPremium
            ? 'Deep analysis across multiple sources for maximum accuracy'
            : 'Free — runs automatically when you start training'}
        </span>
      </div>
    </div>
  );
};
